var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8Erreur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.431,35.294L27.949,7.328C27.142,5.871,25.666,5,24,5s-3.142,0.871-3.949,2.328L4.569,35.294 c-0.783,1.415-0.761,3.09,0.061,4.483C5.45,41.169,6.904,42,8.519,42h30.963c1.614,0,3.068-0.831,3.889-2.223 C44.191,38.385,44.214,36.709,43.431,35.294z M22.5,17.5c0-0.829,0.672-1.5,1.5-1.5s1.5,0.671,1.5,1.5v10c0,0.829-0.672,1.5-1.5,1.5 s-1.5-0.671-1.5-1.5V17.5z M24,36c-1.105,0-2-0.895-2-2c0-1.105,0.895-2,2-2s2,0.895,2,2C26,35.105,25.105,36,24,36z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Erreur);
export default __webpack_public_path__ + "static/media/icons8-erreur.12e6d278378fda42a50a9fe59e6c60fe.svg";
export { ForwardRef as ReactComponent };